var _circle, _circle2, _path, _circle3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 136,
    viewBox: "0 0 92 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.9429,
    cy: 36.8292,
    r: 6.82918,
    fill: "#FD504F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 27,
    r: 13,
    fill: "#FD504F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5511 49.4389C31.4191 48.7782 30.9357 48.2428 30.2918 48.0442C29.5686 47.8212 28.7827 48.0647 28.3124 48.6576L25.6097 52.0648C23.7585 54.3984 20.7904 55.5017 17.8235 55.2372C10.5519 54.5888 3.04597 55.1701 -4.42021 57.1407C-38.9518 66.255 -59.5567 101.637 -50.4425 136.169C-41.3282 170.7 -5.9463 191.305 28.5853 182.191C63.1169 173.077 83.7218 137.695 74.6076 103.163C69.3813 83.3617 55.5177 68.1397 38.13 60.4748C35.2342 59.1983 33.0008 56.6968 32.3809 53.5935L31.5511 49.4389Z",
    fill: "#FD504F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5475,
    cy: 4.54748,
    r: 3.49096,
    transform: "rotate(-22.0902 20.5475 4.54748)",
    fill: "#FD504F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/Red.d8bc66da7857f3093da3400479303412.svg";
export { ForwardRef as ReactComponent };